<template>
    <form class="space-y-3 md:space-y-5" @submit.prevent="sendComment">
        <div class="space-y-1">
            <InputLabel value="Оціни товар"/>

            <ReviewStars v-model="form.rating"/>

            <InputError :message="form.errors.rating"/>
        </div>

        <div class="space-y-1">
            <InputLabel value="Сам відгук"/>
            <Textarea
                v-model="form.content"
                rows="4"/>
            <InputError :message="form.errors.content"/>
        </div>

        <div v-if="! this.$page.props.auth.user" class="grid gap-5 md:grid-cols-2">
            <div class="space-y-1">
                <InputLabel value="Твоє імʼя" required/>
                <TextInput v-model="form.name" required/>
                <InputError :message="form.errors.name"/>
            </div>

            <div class="space-y-1">
                <InputLabel value="Телефон" required/>
                <PhoneInput v-model="form.phone" required/>
                <InputError :message="form.errors.phone"/>
            </div>
        </div>

        <PrimaryButton :loading="form.processing">Надіслати</PrimaryButton>
    </form>
</template>

<script>
import PrimaryButton from "@/Components/PrimaryButton.vue";
import InputLabel from "@/Components/InputLabel.vue";
import TextInput from "@/Components/TextInput.vue";
import Star from "@/Components/Svg/Star.vue";
import {useApiForm} from "@/Helpers/useApiForm/useApiForm.js";
import Textarea from "@/Components/Forms/Textarea.vue";
import PhoneInput from "@/Components/PhoneInput.vue";
import InputError from "@/Components/InputError.vue";
import ReviewStars from '@/Partials/Common/ReviewStars.vue';

export default {
    components: { ReviewStars, InputError, PhoneInput, Textarea, Star, TextInput, InputLabel, PrimaryButton},
    props: {
        product: Object
    },
    data() {
        return {
            form: useApiForm({
                rating: null,
                content: '',
                name: '',
                phone: '',
                type: 'review'
            }),
        }
    },
    methods: {
        sendComment() {
            this.form.post(this.route('products.comments.store', {product: this.product}), {
                onSuccess: () => {
                    this.$emit('sent')

                    this.form.reset('rating', 'content')
                }
            })
        }
    }
}
</script>
